<template>
  <section class="section" id="step-4">
    <h3 class="mt-5">Kontaktní údaje</h3>
    <div class="row mt-3">
      <FormInput
        v-model="authorName"
        label="Jméno nebo firma"
        input-type="text"
        :is-required="true"
        :is-read-only="true"
        :is-disabled="true"
        sub-label="Bude zveřejněno"
        css-style="col-xl-6 pt-lg-2 pt-2 pb-lg-3 pb-2"
      />
      <FormInput
        v-model="contactEmail"
        label="Kontaktní e-mail"
        input-type="text"
        :is-required="true"
        :is-read-only="true"
        :is-disabled="true"
        sub-label="Jen k přeposlání písemných nabídek"
        css-style="col-xl-6 pt-lg-2 pt-2 pb-lg-3 pb-2"
      />
      <FormInput
        v-model="contactPhone"
        label="Kontaktní telefon"
        input-type="text"
        input-mode="numeric"
        masked-type="phone"
        max-length="11"
        prepend="+420"
        :is-required="true"
        sub-label="Bude zveřejněn"
        css-style="col-xl-6 pt-lg-2 pt-2 pb-lg-3 pb-2"
      />

      <!-- Address autocomplete -->
      <div :class="{ 'bg-info-lighter': !city }" class="col-12 pt-lg-2 pt-2 pb-lg-3 pb-2">
        <label class="form-label">Lokalita vozidla <span class="form-label__required" /></label>
        <div class="form-label__info-text">Díky vyplněné lokalitě se váš inzerát zobrazí lidem ve vašem okolí.</div>
        <div style="position: relative">
          <input
            type="text"
            class="form-control form-control-lg"
            placeholder="Začněte psát město nebo adresu..."
            autocomplete="off"
            :value="addressSearch"
            @input="onAddressInput"
            @keydown.enter.prevent
          >
          <div v-if="showSuggestions && suggestions.length" class="address-suggest-dropdown">
            <button
              v-for="(item, i) in suggestions"
              :key="i"
              type="button"
              class="address-suggest-item"
              @click="selectSuggestion(item)"
            >
              {{ item.label }}
            </button>
          </div>
        </div>
      </div>

      <template v-if="city">
        <FormInput
          v-model="street"
          label="Ulice a číslo popisné"
          input-type="text"
          sub-label="Nepovinné"
          css-style="col-8 pt-lg-2 pt-2 pb-lg-3 pb-2"
        />
        <FormInput
          v-model="zipCode"
          label="PSČ"
          input-type="text"
          :is-required="true"
          css-style="col-4 pt-lg-2 pt-2 pb-lg-3 pb-2 align-self-end"
        />
        <FormInput
          :model-value="city"
          label="Město"
          input-type="text"
          :is-required="true"
          :is-read-only="true"
          :is-disabled="true"
          css-style="col-xl-6 pt-lg-2 pt-2 pb-lg-3 pb-2"
        />
        <FormInput
          :model-value="districtName"
          label="Okres"
          input-type="text"
          :is-read-only="true"
          :is-disabled="true"
          css-style="col-xl-6 pt-lg-2 pt-2 pb-lg-3 pb-2"
        />
        <FormSelectSimple
          id="region"
          v-model="region"
          :model-value="region"
          :options="regions"
          label="Kraj"
          :is-required="true"
          :is-disabled="true"
          css-style="col-xl-6 pt-lg-2 pt-2 pb-lg-3 pb-2"
        />
      </template>

      <FormTextArea
        v-model="authorDescription"
        label="Další informace o prodávajícím"
        :show-length-counter="true"
        :max-length="1000"
        :rows-count="5"
        placeholder="Uveďte například kdy vám mohou zájemci volat, kde je možné auto vidět a další upřisnění ohledně prodeje..."
        css-style="col-12 pt-lg-2 pt-2 pb-lg-3 pb-2"
        sub-label="Praktické informace k prodeji."
      />
    </div>
  </section>
</template>

<script>
import ApiService from '../../../services/apiService.js';
import HelperService from '../../../services/helperService.js';
import FormInput from '../../FormInput.vue';
import FormTextArea from '../../FormTextArea.vue';
import FormSelectSimple from '../../FormSelectSimple.vue';
import { fetchAddressSuggestions, parseAddressItem, fetchZipForCity } from '../../../../js/address-suggest.js';

export default {
  name: 'ContactInfoStep',

  components: {
    FormInput,
    FormTextArea,
    FormSelectSimple,
  },

  data() {
    return {
      addressSearch: '',
      suggestions: [],
      showSuggestions: false,
      debounceTimer: null,
      regions: HelperService.objectMapper([
        'Hlavní město Praha',
        'Středočeský kraj',
        'Jihočeský kraj',
        'Jihomoravský kraj',
        'Karlovarský kraj',
        'Královehradecký kraj',
        'Liberecký kraj',
        'Moravskoslezský kraj',
        'Olomoucký kraj',
        'Pardubický kraj',
        'Plzeňský kraj',
        'Ústecký kraj',
        'Vysočina',
        'Zlínský kraj',
      ]),
    };
  },

  computed: {
    authorName: {
      get() { return this.$store.state.AdvertisementStore.advertisement.authorName; },
      set(value) { this.$store.commit('AdvertisementStore/authorName', value); },
    },
    contactEmail: {
      get() { return this.$store.state.AdvertisementStore.advertisement.contactEmail; },
      set(value) { this.$store.commit('AdvertisementStore/contactEmail', value); },
    },
    contactPhone: {
      get() { return this.$store.state.AdvertisementStore.advertisement.contactPhone; },
      set(value) { this.$store.commit('AdvertisementStore/contactPhone', value); },
    },
    region: {
      get() { return this.$store.state.AdvertisementStore.advertisement.region; },
      set(value) { this.$store.commit('AdvertisementStore/region', value); },
    },
    authorDescription: {
      get() { return this.$store.state.AdvertisementStore.advertisement.authorDescription; },
      set(value) { this.$store.commit('AdvertisementStore/authorDescription', value); },
    },
    street: {
      get() { return this.$store.state.AdvertisementStore.advertisement.street; },
      set(value) { this.$store.commit('AdvertisementStore/street', value); },
    },
    zipCode: {
      get() { return this.$store.state.AdvertisementStore.advertisement.zipCode; },
      set(value) { this.$store.commit('AdvertisementStore/zipCode', value); },
    },
    city: {
      get() { return this.$store.state.AdvertisementStore.advertisement.city; },
      set(value) { this.$store.commit('AdvertisementStore/city', value); },
    },
    districtName: {
      get() { return this.$store.state.AdvertisementStore.advertisement.districtName; },
      set(value) { this.$store.commit('AdvertisementStore/districtName', value); },
    },
  },

  async mounted() {
    const { data } = await ApiService.get('users/current');
    const u = data.currentUser;

    // Only populate from user profile if the store values are not already set
    // (e.g. user navigated back to this step after already filling it in)
    if (this.authorName === undefined) this.authorName = u.name;
    if (this.contactEmail === undefined) this.contactEmail = u.contactEmail;
    if (this.contactPhone === undefined) this.contactPhone = u.contactPhone;
    if (this.region === undefined) this.region = u.region;
    if (this.authorDescription === undefined) this.authorDescription = u.authorDescription;
    if (this.street === undefined) this.street = u.street;
    if (this.zipCode === undefined) this.zipCode = u.zipCode;
    if (this.city === undefined) this.city = u.city;
    if (this.districtName === undefined) this.districtName = u.districtName;

    if (this.city) {
      this.addressSearch = [this.street, this.city].filter(Boolean).join(', ');
    }

    document.addEventListener('click', this.onOutsideClick);
  },

  beforeUnmount() {
    document.removeEventListener('click', this.onOutsideClick);
  },

  methods: {
    onAddressInput(e) {
      this.addressSearch = e.target.value;
      clearTimeout(this.debounceTimer);
      const query = this.addressSearch.trim();
      if (query.length < 2) { this.showSuggestions = false; return; }
      this.debounceTimer = setTimeout(async () => {
        const items = await fetchAddressSuggestions(query);
        this.suggestions = items.map(parseAddressItem);
        this.showSuggestions = true;
      }, 300);
    },

    async selectSuggestion(parsed) {
      let zip = parsed.zip;
      if (!zip && parsed.city) {
        zip = await fetchZipForCity(parsed.city, parsed.street);
      }

      this.street = parsed.street;
      this.zipCode = zip;
      this.city = parsed.city;
      this.districtName = parsed.districtName;
      this.region = parsed.regionName || this.region;
      this.addressSearch = [parsed.street, parsed.city].filter(Boolean).join(', ');
      this.showSuggestions = false;
    },

    onOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.showSuggestions = false;
      }
    },
  },
};
</script>
